﻿function initEmblaCarousels() {
    document.querySelectorAll(".embla").forEach(function (root) {
        const viewport = root.querySelector(".embla__viewport");
        if (!viewport) return;

        if (root.offsetParent === null) return;
        if (root.embla) return;

        const embla = EmblaCarousel(viewport, {
            align: "start",
            dragFree: true,
            containScroll: "trimSnaps"
        });

        root.embla = embla;

        const activeSlide = root.querySelector(".embla__slide .context-chip.active")?.closest(".embla__slide");
        if (activeSlide) {
            const slides = Array.from(root.querySelectorAll(".embla__slide"));
            const activeIndex = slides.indexOf(activeSlide);

            if (activeIndex >= 0) {
                embla.scrollTo(activeIndex, true);
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initEmblaCarousels();
});

window.addEventListener("resize", function () {
    document.querySelectorAll(".embla").forEach(function (root) {
        if (root.embla) {
            root.embla.reInit();
        }
    });
});